import { IChannelNotificationResponse } from "@wingspanhq/notifications/dist/lib/interfaces";
import { selectorActiveNotifications } from "./selectorActiveNotifications";

import { NotificationHandleType } from "../components/Notifications";
import { IdentityVerificationRequestContractorContext } from "../components/Notifications/templates/IdentityVerificationRequestContractor";

export const selectorIdentityVerificationRequestContractorNotifications = (
  responses: IChannelNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return (
      response.handle ===
      NotificationHandleType.IdentityVerificationRequestContractor
    );
  }) as Array<
    Omit<IChannelNotificationResponse, "context"> & {
      context: IdentityVerificationRequestContractorContext;
    }
  >;
};
